import { useEditor } from "features/editor/Feature";
import { Box } from "prism-react";
import React from "react";

import type { BranchTitleProps } from "./implementations/RepositoryTitle";
import { RepositoryTitle } from "./implementations/RepositoryTitle";
import { SandboxTitle } from "./implementations/SandboxTitle";
import { useTitleState } from "./useTitleState";

const { Provider: TitleStateProvider } = useTitleState;

/**
 * @todo this should be renamed to a more generic *Title
 */
export const EditorTitle: React.FC<BranchTitleProps> = (props) => {
  const project = useEditor();

  return (
    <Box
      css={{
        overflow: "hidden",
      }}
    >
      <TitleStateProvider>
        {project.type === "sandbox" ? (
          <SandboxTitle />
        ) : (
          <RepositoryTitle {...props} />
        )}
      </TitleStateProvider>
    </Box>
  );
};
